"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReviewStatusFilteredProductsRefetch = void 0;
const react_1 = require("react");
const products_table_constants_1 = require("../products-table.constants");
const FILTERED_PRODUCTS_REFETCH_DEBOUNCE_MS = 1000;
const useReviewStatusFilteredProductsRefetch = ({ tableFilter, refetchProductList, scheduleProgressRefresh, }) => {
    const pendingReviewStatusMutationsRef = (0, react_1.useRef)(new Set());
    const productsRefetchTimerRef = (0, react_1.useRef)(null);
    const hasReviewedStatusFilter = (0, react_1.useMemo)(() => (tableFilter.items.some(({ field }) => field === products_table_constants_1.REVIEWED_COLUMN_ID)), [tableFilter]);
    const scheduleFilteredProductsRefetch = (0, react_1.useCallback)((change) => {
        if (!change || !hasReviewedStatusFilter)
            return;
        pendingReviewStatusMutationsRef.current.add(change);
        if (productsRefetchTimerRef.current) {
            clearTimeout(productsRefetchTimerRef.current);
        }
        productsRefetchTimerRef.current = setTimeout(() => {
            productsRefetchTimerRef.current = null;
            const pending = [...pendingReviewStatusMutationsRef.current];
            pendingReviewStatusMutationsRef.current.clear();
            void Promise.allSettled(pending.map(({ mutation }) => mutation))
                .then((results) => {
                if (results.some((result) => result.status === 'fulfilled')) {
                    void refetchProductList();
                }
            });
        }, FILTERED_PRODUCTS_REFETCH_DEBOUNCE_MS);
    }, [hasReviewedStatusFilter, refetchProductList]);
    const handleReviewStatusChange = (0, react_1.useCallback)((change) => {
        scheduleProgressRefresh(change);
        scheduleFilteredProductsRefetch(change);
    }, [scheduleFilteredProductsRefetch, scheduleProgressRefresh]);
    (0, react_1.useEffect)(() => () => {
        if (productsRefetchTimerRef.current) {
            clearTimeout(productsRefetchTimerRef.current);
        }
    }, []);
    return handleReviewStatusChange;
};
exports.useReviewStatusFilteredProductsRefetch = useReviewStatusFilteredProductsRefetch;
